import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Grid from '@material-ui/core/Grid';
import styles from './styles';
import messages from './messagesPlusBusSupplements';
import RenderPlusBusSupplements from './RenderPlusBusSupplements';

const PlusBusSupplementTravelSegment = ({
    legid,
    travelSegments,
    searchedPlusBusSupplements,
    onCheckPlusBusSupplement,
    intl,
    classes,
    isToggled,
    setIsToggled,
}) => {
    // let passengerCount = 0;

    const { formatMessage } = intl;
    const getExpandedTravelSegmentId = () => {
        const segmentIds = travelSegments && travelSegments[legid].map((travelSegment) => travelSegment?.TravelSegmentID);
        return segmentIds && segmentIds[0];
    };
    const [expanded, setExpanded] = useState(getExpandedTravelSegmentId());
    const lblTo = formatMessage(messages.lblTo);
    const expandable = searchedPlusBusSupplements && searchedPlusBusSupplements.length > 0;

    const getPassengerLabel = (label) => `Passenger ${parseInt(label.substring(label.lastIndexOf('_') + 1), 10) + 1}`;

    const handleSummaryClick = (tsID) => (event, expandedValue) => {
        setExpanded(expandedValue && tsID);
    };
    return (
        <>
            {
                travelSegments && travelSegments[legid].map((travelSegment) => (
                    <ExpansionPanel
                        key={`ExpansionPanel${legid}${travelSegment.TravelSegmentID}`}
                        expanded={expanded === travelSegment.TravelSegmentID}
                        onChange={expandable ? handleSummaryClick(travelSegment.TravelSegmentID) : undefined}
                        classes={{ expanded: classes.expandedPanel }}
                    >
                        <ExpansionPanelSummary
                            expandIcon={expandable && <ExpandMoreIcon />}
                            classes={{
                                root: classes.legSegment,
                                content: classes.legSegmentSummary,
                                expanded: classes.expandedPanelSummary,
                            }}
                        >
                            {`${travelSegment.ShoppingFareDepartStationSegment} ${lblTo} ${travelSegment.ShoppingFareArriveStationSegment}`}
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails key={`ExpansionPanelDetails${legid}${travelSegment.TravelSegmentID}`}>
                            <Grid container spacing={8}>
                                <Grid item xs={8} />
                                {searchedPlusBusSupplements?.map((plusBusSupplement, index) => plusBusSupplement && plusBusSupplement.linkedTravelSegments[0] === travelSegment.TravelSegmentID && (
                                    <Grid item xs={false} key={`Grid${index}`}>
                                        <RenderPlusBusSupplements
                                            key={`RenderPlusBusSupplements${index}`}
                                            plusBusSupplement={plusBusSupplement}
                                            searchedPlusBusSupplements={searchedPlusBusSupplements}
                                            onCheckPlusBusSupplement={onCheckPlusBusSupplement}
                                            isToggled={isToggled}
                                            setIsToggled={setIsToggled}
                                            passengerLabel={getPassengerLabel(plusBusSupplement.linkedPassengers[0])}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                ))
            }
        </>
    );
};

PlusBusSupplementTravelSegment.propTypes = {
    intl: PropTypes.object,
    onCheckPlusBusSupplement: PropTypes.func.isRequired,
    travelSegments: PropTypes.array.isRequired,
    searchedPlusBusSupplements: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
    legid: PropTypes.number.isRequired,
    isToggled: PropTypes.array,
    setIsToggled: PropTypes.func,
};

export { PlusBusSupplementTravelSegment as PlusBusSupplementTravelSegmentAlias };

export default injectIntl(withStyles(styles)(PlusBusSupplementTravelSegment));
